import { render, staticRenderFns } from "./editchannel.vue?vue&type=template&id=5b2ded4b&scoped=true"
import script from "./editchannel.vue?vue&type=script&lang=js"
export * from "./editchannel.vue?vue&type=script&lang=js"
import style0 from "./editchannel.vue?vue&type=style&index=0&id=5b2ded4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2ded4b",
  null
  
)

export default component.exports